var render = function render(){var _vm=this,_c=_vm._self._c;return _c('van-picker',{attrs:{"show-toolbar":"","columns":_vm.columns},on:{"cancel":_vm.cancel,"confirm":_vm.onConfirm,"change":_vm.onChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }